import { MRT_BLUE_STATION_ID, BTS_SILOM_STATION_ID, Graph, BTS_SUKHUMVIT_STATION_ID, ARL_STATION_ID, BRT_STATION_ID, Intersection, METRO_STATION_ID, BTS_GOLD_ID } from "../types";
import { BTS_GOLD_LINE, ARL_LINE, BRT_LINE, BTS_SILOM_LINE, BTS_SUKHUMVIT_LINE, MRT_BLUE_LINE } from ".";

export const ALL_INTERSECTIONS: Intersection[] = [
    [MRT_BLUE_STATION_ID.SILOM, BTS_SILOM_STATION_ID.SALA_DAENG],
    [MRT_BLUE_STATION_ID.BANG_WA, BTS_SILOM_STATION_ID.BANG_WA],

    [MRT_BLUE_STATION_ID.SUKHUMVIT, BTS_SUKHUMVIT_STATION_ID.ASOK],
    [MRT_BLUE_STATION_ID.CHATUCHAK_PARK, BTS_SUKHUMVIT_STATION_ID.MO_CHIT],
    [MRT_BLUE_STATION_ID.PHAHON_YOTHIN, BTS_SUKHUMVIT_STATION_ID.HA_YEAK_LAT_PHRAO],

    [MRT_BLUE_STATION_ID.PHETCHABURI, ARL_STATION_ID.MAKKASAN],
    [BTS_SUKHUMVIT_STATION_ID.PHAYA_THAI, ARL_STATION_ID.PHAYA_THAI],

    [BTS_SILOM_STATION_ID.CHONG_NONSI, BRT_STATION_ID.SATHON],
    [BTS_SILOM_STATION_ID.TALAT_PHLU, BRT_STATION_ID.RATCHAPRUEK],

    [BTS_SILOM_STATION_ID.KRUNG_THON_BURI, BTS_GOLD_ID.KRUNG_THON_BURI],
];

export const EXTENSION_BORDER_STATIONS: METRO_STATION_ID[] = [
    BTS_SILOM_STATION_ID.WONGWIAN_YAI,
    BTS_SUKHUMVIT_STATION_ID.ON_NUT,
    BTS_SUKHUMVIT_STATION_ID.BEARING,
    BTS_SUKHUMVIT_STATION_ID.MO_CHIT,
];

export const METRO_GRAPH: Graph = {
    lines: [
        MRT_BLUE_LINE,
        BTS_SILOM_LINE,
        BTS_SUKHUMVIT_LINE,
        BTS_GOLD_LINE,
        ARL_LINE,
        BRT_LINE,
    ],
    intersections: ALL_INTERSECTIONS
}